import { positive, validDate, validStatus, type DoseStatus } from '../pk/validation';

/** Confirmed means taken. Future entries remain pending until explicitly confirmed. */
export function prepareDose(
  input: { amount: number; takenAt: Date; status: string },
  now = new Date(),
): { amount: number; takenAt: Date; status: DoseStatus } {
  positive(input.amount, 'Dose amount');
  validDate(input.takenAt, 'Dose time');
  validDate(now, 'Current time');
  const status = validStatus(input.status);
  return {
    amount: input.amount,
    takenAt: input.takenAt,
    status: status === 'confirmed' && +input.takenAt > +now ? 'pending' : status,
  };
}
